// The AVenue marks, from the brand pack v1.1 (September 2026; the files are in docs/brand). Two
// marks, used apart and never side by side: the wordmark is the logo; the A icon stands in for it
// only where the name will not fit or is clear from context — the tab, the app icon, small UI.

/**
 * The A: a road running to its vanishing point. Pure geometry, so it takes the colour of its
 * text. At 20px and below the pack's small-size cut is used, whose heavier stroke keeps the
 * counter open.
 */
export function BrandIcon({ size, className }: { size: number; className?: string }) {
  const small = size <= 20;
  return small ? (
    <svg viewBox="0 0 43.46 50.69" height={size} className={className} aria-hidden>
      <polygon
        points="0,50.69 21.73,0 43.46,50.69 32.58,50.69 21.73,25.38 10.88,50.69"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 40.2 46.88" height={size} className={className} aria-hidden>
      <polygon
        points="0,46.88 20.1,0 40.2,46.88 32.58,46.88 20.1,17.76 7.62,46.88"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * The wordmark, full colour for a light ground. Supplied as artwork, never retyped (the pack's
 * rule), so it is the pack's own image. It is at least 100px wide, and keeps clear space equal
 * to its cap height on every side.
 */
export function Wordmark({ height = 20 }: { height?: number }) {
  return (
    <img
      src="/brand/avenue-wordmark-colour.png"
      alt="AVenue"
      height={height}
      width={Math.round((height * 1640) / 256)}
      className="block"
      style={{ margin: `${height * 0.2}px 0` }}
    />
  );
}
